import { IEmojiLocalization } from '@getaccept/lib-ui';
import { translate } from '@lib-shared/helpers/translation.helper';

export class ChatHelper {
  static getEmojiLocalization(): IEmojiLocalization {
    return {
      choose: translate('choose').toString(),
      search: translate('find-your-emoji').toString(),
      notfound: translate('no-emoji-found').toString(),
      searchresult: translate('search-results').toString(),
      recent: translate('frequently-used').toString(),
      smileys: translate('smileys-and-emoticon').toString(),
      people: translate('people-and-body').toString(),
      nature: translate('animals-and-nature').toString(),
      foods: translate('food-and-drink').toString(),
      activity: translate('activity').toString(),
      places: translate('travel-and-places').toString(),
      objects: translate('objects').toString(),
      symbols: translate('symbols').toString(),
      flags: translate('flags').toString(),
      custom: translate('custom').toString(),
    };
  }
}
